<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="120px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.gatewaySN')">
                  <el-input
                    v-model="formselect.gsn"
                    style="width: 100%"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.SIMNumber')">
                  <el-input
                    v-model="formselect.sim"
                    style="width: 100%"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('acronym.gatewayBindingStatus')">
                  <el-select
                    size="small"
                    v-model="formselect.gatewayState"
                    :placeholder="$t('desc.select')"
                  >
                    <el-option value="全部" :label="$t('desc.all')"></el-option>
                    <el-option :label="$t('title.Bound')" value="1"></el-option>
                    <el-option
                      :label="$t('title.Unbound')"
                      value="0"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              
              
            </el-row>
              
            <el-row>
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.creatTime')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="formselect.times"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button
                  @click="getDataList('search')"
                  type="primary"
                  size="small"
                  >{{ $t("button.query") }}</el-button
                >
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <template>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasCreateAuth"
              >{{ $t("button.addGateway") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-upload2"
              @click="showImportDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasImportAuth"
              >{{ $t("button.bulkImport") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-download"
              style="margin-bottom: 10px"
              @click="exportList()"
              :loading="loading"
              v-if="hasExportAuth"
              >{{ $t("button.exportAll") }}</el-button
            >
            <a
              v-if="activeLang == 'en'"
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/Excel Import Template - Gateway.xlsx"
              download="Excel Import Template - Gateway.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <a
              v-else
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/EXCEL导入模板-网关.xlsx"
              download="EXCEL导入模板-网关.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="gsn"
                  :label="$t('desc.gatewaySN')"
                  min-width="150"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="gatherStatus"
                  :label="$t('title.isBinding')"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <label>{{
                      scope.row.gatherStatus == "已绑定"
                        ? $t("title.Bound")
                        : $t("title.Unbound")
                    }}</label>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                prop="awsThingCert"
                :label="$t('title.isRegister')"
                min-width="100"
              >
                <template slot-scope="scope">
                  <label>{{
                    scope.row.awsThingCert == "已注册"
                      ? $t("title.Registered")
                      : $t("title.Unregistered")
                  }}</label>
                </template>
              </el-table-column> -->
              <el-table-column
                  prop="brandName"
                  :label="$t('title.brand')"
                  min-width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="awsThingCreateTime"
                  :label="$t('title.AwsThingCreateTime')"
                  min-width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="awsConnTime"
                  :label="$t('title.GetConnecTime')"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="gatherTime"
                  :label="$t('title.releaseTime')"
                  min-width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  :label="$t('title.creatTime')"
                  min-width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="firmwareId"
                  :label="$t('title.GatewayFirmwareId')"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="firmwareVersion"
                  :label="$t('title.GatewayFirmwareVersion')"
                  min-width="185"
                >
                </el-table-column>
                <el-table-column
                  prop="simNumber"
                  :label="$t('title.SIMNumber')"
                  min-width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="simLatitude"
                  :label="$t('title.SIMLatitude')"
                  min-width="150"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="location"
                :label="$t('title.GatewayLocation')"
                min-width="150"
              >
              </el-table-column> -->
                <!-- <el-table-column
                prop="networkType"
                :label="$t('title.GatewayNetworkType')"
                min-width="200"
              >
              </el-table-column> -->

                <el-table-column
                  :label="$t('title.operate')"
                  :width="hasDownLoadAuth?150:100"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <!-- <el-button
                      type="primary"
                      icon="el-icon-edit"
                      circle
                      size="mini"
                      @click="dialogEditClient = true"
                    ></el-button> -->

                    <template
                      v-if="hasGatewayLocation && checkSim(scope.row.simNumber)"
                    >
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.confirm')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="green"
                        :title="$t('desc.确定获取定位信息吗')"
                        @confirm="getLocationInfo(scope.row)"
                      >
                        <el-button
                          v-if="hasGatewayLocation && scope.row.simNumber"
                          type="primary"
                          icon="el-icon-location-information"
                          :title="$t('button.loaction')"
                          circle
                          size="mini"
                          slot="reference"
                        ></el-button>
                      </el-popconfirm>
                    </template>

                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.delete')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="deleteGateway(scope.row.gsn)"
                      >
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                          v-show="hasDeleteAuth"
                        ></el-button>
                      </el-popconfirm>
                    </template>

                    <template>
                      <el-button
                        type="default"
                        icon="el-icon-download"
                        circle
                        size="mini"
                        :title="$t('RunningTIme.DownloadReport')"
                        v-show="scope.row.isShowDownload && hasDownLoadAuth"
                        @click="downLoadFileFromS3(scope.row)"
                      >
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <gateway-dialog
      ref="addRef1"
      :title="(dialogTitle = $t('button.addGateway'))"
      :gsnForm="gsnForm"
      :dialogAddClient="dialogAddClient"
      :subButtonAuth="hasCreateAuth"
      :loading="submitLoading"
      @onSubBtn="addGateway"
      @dialogVisibleEvent="showDialog"
    >
    </gateway-dialog>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('title.batchImportGetway'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      :loading="importLoading"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
  </div>
</template>

<script>
import {
  CreateMenu,
  GetAllMenus,
  DeleteMenu,
  UpdateMenu,
  getGateways,
  getByGsn,
  addGateway,
  deleteGateway,
  importGateway,
  authOperationCheck,
  GetLocationInfo,
  exportExcelNew,
  downLoadFoldFileFromS3,
  downLoadGsnFileFromS3
} from "../../api/api";
import gatewayDialogComponent from "../../components/content/maintabber/GatewayDialog";
import agencyImportComponent from "../../components/content/maintabber/ExportExcelFile";
import { mapState, mapGetters } from "vuex";

export default {
  name: "index",
  components: {
    "gateway-dialog": gatewayDialogComponent,
    "import-dialog": agencyImportComponent,
  },
  data() {
    return {
      submitLoading:false,
      loading: false,
      importLoading: false,
      dialogTitle: "",
      dialogAddClient: false,
      dialogEditClient: false,
      dialogImportClient: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasImportAuth: false,
      hasExportAuth: false,
      hasGatewayLocation: false,
      hasDownLoadAuth: false,
      formselect: {},
      tableData1: [],
      gsnForm: {
        gsn: "",
        gatewayName: "",
        softwareVersion: "",
        sIMNumber: "",
        signalLevel: "",
        girmwareId: "",
        location: "",
        networkType: "",
      },
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      form: {
        datalist: [],
      },
    };
  },
  created: function () {
    this.authOperation("Gateway");
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  async mounted() {
    this.getDataList();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasImportAuth = res.hasImportAuth;
      that.hasGatewayLocation = res.hasGatewayLocation;
      that.hasExportAuth = res.hasExportAuth;
      that.hasDownLoadAuth = res.hasDownLoadAuth;
    },
    getDataList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        Gsn: this.formselect.gsn,
        Times:this.formselect.times,
        Sim:this.formselect.sim,
        GatewayState:this.formselect.gatewayState,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      getGateways(postData).then((res) => {
        let data = res.result.items;
        this.pagination.totalPage = res.result.totalCount;
        for (let index = 0; index < data.length; index++) {
          data[index].gatherStatus =
            data[index].gatherStatus == "1" ? "已绑定" : "未绑定";
          data[index].awsConnStatus =
            data[index].awsConnStatus == "1" ? "已获取" : "未获取";
          data[index].awsThingCert = data[index].awsThingCert
            ? "已注册"
            : "未注册";
          data[index].awsConnTime =
            data[index].awsConnTime == null
              ? ""
              : data[index].awsConnTime
                  .toString()
                  .replace("T", " ")
                  .substr(0, 19);
          data[index].gatherTime =
            data[index].gatherTime == null
              ? ""
              : data[index].gatherTime
                  .toString()
                  .replace("T", " ")
                  .substr(0, 19);
          data[index].awsThingCreateTime =
            data[index].awsThingCreateTime == null
              ? ""
              : data[index].awsThingCreateTime
                  .toString()
                  .replace("T", " ")
                  .substr(0, 19);
        }
        that.tableData1 = data;
      });
    },
    addGateway() {
      let that = this;
      that.submitLoading = true;
      that.gsnForm.gatewayName = that.gsnForm.gsn;
      addGateway(that.gsnForm)
        .then((res) => {
          that.submitLoading = false;
          that.dialogAddClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          that.submitLoading = false;
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    deleteGateway(e) {
      let that = this;
      let data = { gsn: e };
      deleteGateway(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          if (err != undefined) {
            that.$message({
              showClose: true,
              message: err.error.message,
              type: "error",
            });
          }
        });
    },
    getByGsn(e) {
      let that = this;
      let data = { gsn: e };
      getByGsn(data).then((res) => {
        that.clientform = res.result;
        that.clientform.customerCenter = res.result.RegionList;
      });
    },

    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    handleAccredit(index, row) {},
    handleDelete(index, row) {},
    onSubmit() {},

    showDialog(visible) {
      this.dialogAddClient = visible;
      if (visible) {
        if (this.$refs.addRef1.$refs.gsnForm != undefined) {
          this.$refs.addRef1.$refs.gsnForm.resetFields();
        }
        this.gsnForm = {
          gsn: "",
          softwareVersion: "",
          sIMNumber: "",
          signalLevel: "",
          firmwareId: "",
          location: "",
          networkType: "",
        };
        let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
        this.$set(this.gsnForm, "brandCode", brand);
      }
    },
    showEditDialog(visible, id) {
      this.dialogEditClient = visible;
      if (visible) {
        this.getByGsn(id);
      } else {
        this.gsnForm = {
          gsn: "",
          softwareVersion: "",
          sIMNumber: "",
          signalLevel: "",
          firmwareId: "",
          location: "",
          networkType: "",
        };
      }
    },
    resetKeyword() {
      this.formselect = {};
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDataList();
    },
    showImportDialog(visible) {
      this.dialogImportClient = visible;
      this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    async downLoadFileFromS3(row){
      let that=this;
      let res = await downLoadGsnFileFromS3(row.fileKey);
      // const blob = new Blob([res]);//处理文档流
      const fileName = row.keyName;
      const elink = document.createElement('a');
      elink.download = fileName;
      elink.style.display = 'none';
      // elink.target = "_blank"
      elink.href = res.result;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    uploadFile() {
      let that = this;
      this.importLoading = true;
      var datalist = that.form.datalist;
      var propertys = Object.keys(datalist[0]);

      var msgArr = [];
      var index = 2;
      var postData = [];
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == 'en') {
          obj.Gsn = v["Gsn"];
          obj.BrandCode = v["Brand"];
        } else {
          obj.Gsn = v["网关SN号"];
          obj.BrandCode = v["品牌"];
        }
        
        if (obj.Gsn == undefined || obj.Gsn == "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:") + that.$t("importError.gsnIsEmpty"));
        } else {
          if (that.find(postData, obj) > -1) {
            msgArr.push(
              that.$t("importError.exceptionLine") +
                index +
                that.$t("importError.行异常:")+
                that.$t("importError.theSameGsnAlreadyExists") +
                obj.Gsn
            );
          } else {
            postData.push(obj);
          }
        }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        return false;
      }

      importGateway(postData, 2 * 60 * 1000)
        .then((res) => {
          this.importLoading = false;
          that.dialogImportClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    find(array, model) {
      var index = array.findIndex((item) => item.Gsn === model.Gsn);
      return index; // -1 说明array中不存在id为str的对象
    },
    //SIM 卡号规则判断
    checkSim(SimNo) {
      var numReg = /^[0-9]*$/;
      var numRe = new RegExp(numReg);
      if (SimNo) {
        if (SimNo.length != 15) {
          return false;
        } else if (!numRe.test(SimNo)) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    //定位操作
    getLocationInfo(row) {
      GetLocationInfo(row.simNumber)
        .then((res) => {
          if (res.result.result.length > 0) {
            this.$message.success("success");
            that.getDataList();
          } else {
            this.$message.error(res.result.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    exportList() {
      let that = this;
      that.loading = true;
      var exportData = [
        [
          that.$t('desc.gatewaySN'),
          that.$t('title.isBinding'),
          that.$t('title.AwsThingCreateTime'),
          that.$t('title.GetConnecTime'),
          that.$t('title.releaseTime'),
          that.$t('title.creatTime'),
          that.$t('title.GatewayFirmwareId'),
          that.$t('title.GatewayFirmwareVersion'),
          that.$t('title.SIMNumber'),
          that.$t('title.SIMLatitude'),
        ],
      ];

      var fileName = that.$t("exportContent.空压机网关列表") + ".xlsx";
      let postData = {
        Gsn: this.formselect.gsn,
        Times:this.formselect.times,
        Sim:this.formselect.sim,
        GatewayState:this.formselect.gatewayState,
        SkipCount: 0,
        MaxResultCount: 999999,
      };
      getGateways(postData).then((res) => {
        if (res.result) {
          let data = res.result.items;
          for (let index = 0; index < data.length; index++) {
            data[index].gatherStatus =
              data[index].gatherStatus == "1" ? "已绑定" : "未绑定";
            data[index].awsConnStatus =
              data[index].awsConnStatus == "1" ? "已获取" : "未获取";
            data[index].awsThingCert = data[index].awsThingCert
              ? "已注册"
              : "未注册";
            data[index].awsConnTime =
              data[index].awsConnTime == null
                ? ""
                : data[index].awsConnTime
                    .toString()
                    .replace("T", " ")
                    .substr(0, 19);
            data[index].gatherTime =
              data[index].gatherTime == null
                ? ""
                : data[index].gatherTime
                    .toString()
                    .replace("T", " ")
                    .substr(0, 19);
            data[index].awsThingCreateTime =
              data[index].awsThingCreateTime == null
                ? ""
                : data[index].awsThingCreateTime
                    .toString()
                    .replace("T", " ")
                    .substr(0, 19);
          }
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [];
            rowData = [
              item.gsn,
              item.gatherStatus == "已绑定"
                ? this.$t("title.Bound")
                : this.$t("title.Unbound"),
              item.awsThingCreateTime,
              item.awsConnTime,
              item.gatherTime,
              item.createTime,
              item.firmwareId,
              item.firmwareVersion,
              item.simNumber,
              item.simLatitude,
            ];
            exportData.push(rowData);
          });
          exportExcelNew(exportData, fileName);
          // exportExcel(headers, dataSource, fileName);
          that.loading = false;
        }
      });
    },
  },
};
</script>

 